export default {
  transitionTimeFast: 100,
  transitionTimeBase: 200,
  transitionTimeSlow: 400,
  transitionFunction: [0.25, 0.46, 0.45, 0.94]
};